import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function narrowStyle({ $narrow }: ButtonStyleProps) {
  if ($narrow) {
    return css`
      padding-right: 1.5rem;
      padding-left: 1.5rem;
      min-width: 0;
    `;
  }
}
